module.exports = __webpack_public_path__ + "bfec58a7016a27a0a053eb2b6b15ee94.png";